document.addEventListener('DOMContentLoaded', function () {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const delay = (entry.target.dataset.revealIndex || 0) * 80;
          setTimeout(() => {
            entry.target.classList.add('is-revealed');
          }, delay);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
  );

  function observeCard(card, index) {
    if (card.dataset.revealObserved) return;
    card.dataset.revealObserved = 'true';
    card.dataset.revealIndex = index % 6;
    observer.observe(card);
  }

  // Observe cards already on the page
  document.querySelectorAll('.product-card').forEach((card, index) => observeCard(card, index));

  // Watch for cards added later (e.g. product recommendations loaded async)
  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('product-card')) {
          observeCard(node, 0);
        }
        node.querySelectorAll?.('.product-card').forEach((card, i) => observeCard(card, i));
      });
    });
  });

  mutationObserver.observe(document.body, { childList: true, subtree: true });
});